import React from 'react';
import { ItemCounter as StyledItemCounter } from './ItemCounter.styles';

export interface ItemCounterProps {
  filtered: number;
  total: number;
  activeCounter?: boolean;
}

export function ItemCounter({
  filtered,
  total,
  activeCounter,
}: ItemCounterProps) {
  return (
    <StyledItemCounter>
      Showing {filtered}/{total}
      {activeCounter ? ' Active' : ''}
    </StyledItemCounter>
  );
}
